import React from 'react';
	
import Spinner from "react-bootstrap/Spinner";
import Header from './Header';
import Footer from './Footer';
import '../Estilos/Estilo.scss';
import ResearchAreas from '../cards/CardResearchAreas';

export default class About extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lineasInvestigacion: [],
			loading: true,
			cardClass:'blog-card',

			
		};

	}
	render() {
		
		return (
			<div className="researchArea">
				<Header />
				<h1 tspace="50">GRyS works in the following research areas</h1>
				<hr/>
				{this.state.loading ? <Spinner/> : <ResearchAreas lineasInv={this.state.lineasInvestigacion} id="linesOfEnv" item='6' />}

				<Footer />
			</div>
		)
	}
	componentDidMount(){
		window.scrollTo(0,0);
		fetch(process.env.PUBLIC_URL+"/assets/json/research-areas.json").then(res=>res.json()).then(lineasInvestigacion=>this.setState({lineasInvestigacion, loading: false}));
		
	}
}